// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alignButton[data-v-4fb01325] {\n  margin-top: -18px !important;\n}\n.alignPhoto[data-v-4fb01325] {\n  margin-top: -28px !important;\n}", ""]);
// Exports
module.exports = exports;
